import React from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import {Page, PagePanel} from "../../components/helpers/PagePanel";
import {ExternalLink} from "../../components/helpers/EasyLinks";
import BeersGallery from "./beers/BeersGallery";
import './About.css'
import pre2013 from './about/pre-2013.png'
import year2013 from './about/2013.png'
import year2014 from './about/2014.png'
import year2015 from './about/2015.png'
import year2016 from './about/2016.png'
import year2017 from './about/2017.png'
import lag from './about/laforge-and-glasius.jpg'

const imgStyle = {
    width: 149, height: 149
};

export const AboutPage = () => (
    <Page>
        <PagePanel title="About GR8Conf">
            <h2>Story-telling time</h2>
            {/*<Zoom>*/}
            <img className="pull-right img-thumbnail" style={{height: 130}} src={lag} alt="Søren Glasius & Guillaume Laforge"/>
            {/*</Zoom>*/}
            <p className="lead">
                In a galaxy far far away… in 2009, Søren invited Guillaume to speak about the Groovy programming language at a conference in Denmark.
                Discussing together, they started brainstorming about a short event to cover the various aspects of the language, the project and its
                ecosystem. This idea sparkle quickly overflowed into a more solid plant to create a dedicated conference fully dedicated to this
                ecosystem, as it was clear that there was way too much to cover than during a simple day workshop. This is how this idea of talking
                about
                “great” technologies, based off the Apache Groovy programming language turned into a full-blown conference named GR8Conf.
            </p>
            <Grid>
                <Row>
                    <Col xs={12} sm={10} smPush={1} className="text-center">
                        <img src={pre2013} alt="GR8Conf EU Pre 2013" style={imgStyle}/>
                        <img src={year2013} alt="GR8Conf EU 2013" style={imgStyle}/>
                        <img src={year2014} alt="GR8Conf EU 2014" style={imgStyle}/>
                        <img src={year2015} alt="GR8Conf EU 2015" style={imgStyle}/>
                        <img src={year2016} alt="GR8Conf EU 2016" style={imgStyle}/>
                        <img src={year2017} alt="GR8Conf EU 2017" style={imgStyle}/>
                    </Col>
                </Row>
            </Grid>
            <p>
                The conference has been growing in size from year to year, starting out with just under 100 attendees, and now reaching closer to 200!
                The
                cosy atmosphere of the conference and social events gives the attendees, speakers, sponsors, and others involved a great chance to
                interact.
            </p>
            <p>
                In 2017 we added DevOps as a focus area, to narrow the gap between the developers and operations, since it's often seen, that
                developers
                takes on the role to setup logging, orchestrating containers and deploying applications to the cloud.
            </p>
            <h3>GR8Conf World Wide</h3>
            <p>In 2010 GR8Conf US was created as a franchise, giving those who cannot travel to Europe a
                chance to get some GR8 content. The US edition is still going strong, and you can visit their website on <ExternalLink
                    link="http://gr8conf.us">www.gr8conf.us</ExternalLink>.
                For two years there were also an Indian version of GR8Conf, but has unfortunately been discontinued by the organizers there.
            </p>
            <h3>GR8Beer</h3>
            <p>
                Every year the GR8Conf Crew brews beer, and 2018 is no exception. The beers will be served at the conference Meet & Greet event, where
                you
                will have a chance to meet the speakers and chat.
            </p>
            <h4>Brewing the beers</h4>
            <p>The gallery below shows the crew brewing and bottling the beers</p>
            <BeersGallery/>

        </PagePanel>
    </Page>
);





// WEBPACK FOOTER //
// ./src/pages/information/About.js